import React, {Component} from 'react';
import * as R from 'ramda';

import FeedbackForm from 'js/components/feedback_form';
import FeedbackPanel from 'js/components/feedback_panel';

export default class RejectionRestrictedDoNotDistributeFeedback extends Component {
    static defaultProps = {
        onCancel: R.identity,
        onSubmit: R.identity
    };

    constructor(props) {
        super(props);
        this.state = {
            selectedOptions: {not_brand_fit: true},
            feedbackText: ''
        };
    }

    onSelect = (selectedOptions) => {
        this.setState({selectedOptions});
    };

    onTextChange = (e) => {
        this.setState({feedbackText: e.target.value});
    };

    onSubmit = () => {
        const {onSubmit} = this.props;
        const {selectedOptions, feedbackText} = this.state;
        const feedback = R.trim(feedbackText);
        onSubmit({
            selectedOptions: R.pipe(R.filter(R.identity), R.keys)(selectedOptions),
            feedbackText: feedback === '' ? null : feedback
        });
    };

    revert = () => {
        this.props.onCancel();
        this.props.onPrevious();
    };

    render() {
        const {isTransmitting} = this.props;
        const {selectedOptions} = this.state;
        const hasSelectedOption = R.any(R.identity, R.values(selectedOptions));

        return (
            <FeedbackPanel
                heading="You have declined to post this piece of content."
                subheading="To improve future content, please provide some feedback on why you chose not to post."
                onCancel={this.revert}
                onSubmit={this.onSubmit}
                submitDisabled={!hasSelectedOption || isTransmitting}
                sameSizeButtons={false}
                submitButtonCopy={'Submit & Continue'}
            >
                <FeedbackForm
                    options={[]}
                    onSelect={this.onSelect}
                    onTextChange={this.onTextChange}
                    usesTextarea
                />
            </FeedbackPanel>
        );
    }
}



// WEBPACK FOOTER //
// ./components/content_review_workflow/rejection_restricted_path/rejection_restricted_dnd_feedback/index.js